import { render, staticRenderFns } from "./nat3_sessions.vue?vue&type=template&id=32c22f0d&"
import script from "./nat3_sessions.vue?vue&type=script&lang=js&"
export * from "./nat3_sessions.vue?vue&type=script&lang=js&"
import style0 from "./nat3_sessions.vue?vue&type=style&index=0&id=32c22f0d&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VDataTable } from 'vuetify/lib/components/VDataTable';
import { VTextField } from 'vuetify/lib/components/VTextField';
import { VToolbar } from 'vuetify/lib/components/VToolbar';
import { VToolbarTitle } from 'vuetify/lib/components/VToolbar';
installComponents(component, {VBtn,VDataTable,VTextField,VToolbar,VToolbarTitle})
